{
  "page": {
    "title": "Users",
    "subtitle": "Manage who can sign in to the Backoffice."
  },
  "error": "Failed to load users. Try refreshing the page.",
  "column": {
    "name": "Name",
    "email": "Email",
    "roles": "Roles",
    "created": "Created",
    "actions": "Actions"
  },
  "empty": {
    "title": "No users yet",
    "body": "No one has been added to the Backoffice yet.",
    "body_can_manage": "Create the first user to give them access to the Backoffice."
  },
  "action": {
    "new_user": "New user",
    "edit": "Edit",
    "set_roles": "Set roles",
    "reset_password": "Reset password",
    "delete": "Delete",
    "cancel": "Cancel",
    "save": "Save"
  },
  "create": {
    "title": "New user",
    "subtitle": "Creates the user with a temporary password. They'll be required to change it on first login.",
    "email_label": "Email",
    "email_placeholder": "name@example.com",
    "name_label": "Name",
    "name_placeholder": "e.g. Somchai Prasert",
    "roles_label": "Roles",
    "err_email_required": "Enter a valid email",
    "err_name_required": "Name is required",
    "err_roles_required": "Select at least one role",
    "submit": "Create user",
    "success_title": "User created",
    "success_description": "Share this with {{name}} through a secure channel. It won't be shown again.",
    "close": "Done"
  },
  "edit": {
    "title": "Edit user",
    "success": "User updated"
  },
  "set_roles": {
    "title": "Set roles for {{name}}",
    "success": "Roles updated"
  },
  "reset_password": {
    "title": "Reset password for {{name}}",
    "description": "This generates a new temporary password and signs the user out everywhere. They'll be required to change it on next login.",
    "confirm": "Reset password",
    "success_title": "Password reset",
    "success_description": "Share this with {{name}} through a secure channel. It won't be shown again.",
    "close": "Done"
  },
  "delete": {
    "title": "Delete {{name}}?",
    "description": "This deactivates the account and signs them out everywhere. This can't be undone from this screen.",
    "success": "User deleted"
  },
  "role": {
    "admin": "Admin",
    "ops": "Ops",
    "viewer": "Viewer"
  }
}
